import { CSSTransition } from 'react-transition-group';
import '../../constants/culture.js';
import 'react';
import { useFocusable } from '../../hooks/useFocusable.js';
import { useTheme } from 'styled-components';
import 'react-error-boundary';
import '../../theme/globalStyles.js';
import { jsx } from 'react/jsx-runtime';
import '../../theme/base/index.js';
import '../../theme/baseFit/index.js';
import '../../theme/pureGym/index.js';
import '../../theme/fitnessWorld/index.js';
import '../list/index.js';
import { useMenu } from './menuContext.js';
import { MenuListItem } from './menuListItem.js';
import { PanelWrapper, MenuList } from './styles.js';
import { LIST_VARIANTS } from '../list/constants.js';

const MenuPanel = _ref => {
  let {
    data,
    visible
  } = _ref;
  const {
    transitions
  } = useTheme();
  const {
    focusableRef
  } = useFocusable();
  const {
    direction,
    menuLevel,
    prevMenuLevel
  } = useMenu();
  const hasData = data && Array.isArray(data);
  const isRtl = direction === 'rtl';
  const menuDirection = prevMenuLevel > menuLevel ? 'up' : 'down';
  if (!hasData) {
    return null;
  }
  return /*#__PURE__*/jsx(CSSTransition, {
    in: visible,
    appear: menuLevel !== 0,
    timeout: transitions.default,
    unmountOnExit: true,
    children: /*#__PURE__*/jsx(PanelWrapper, {
      ref: focusableRef,
      isRtl: isRtl,
      menuDirection: menuDirection,
      children: /*#__PURE__*/jsx(MenuList, {
        variant: LIST_VARIANTS.PLAIN,
        children: data.map((_ref2, i) => {
          let {
            name,
            ...rest
          } = _ref2;
          return /*#__PURE__*/jsx(MenuListItem, {
            name: name,
            index: i,
            ...rest
          }, "".concat(name, "-").concat(i));
        })
      })
    })
  });
};

export { MenuPanel };
